export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7612.ea6fbde7.jpg";